import { EmptyArray } from "../domain/empty/model";
import { SpendTypeRepositoryImplementation } from '../infrastructure/spend-type-repository-implementation';
import { SpendType } from '../domain/spend_type/model';


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new SpendTypeRepositoryImplementation();
const CACHE_PREFIX = 'spend_type';

async function createSpendType(data: Partial<SpendType>, companyId?: string | number) {
  try {
    const result = await repo.createSpendType(data, companyId).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function getSpendType(id: number) {
  try {
    const cacheKey = `${CACHE_PREFIX}-detail-${id}`;
    const cached = cacheManager.getItem(cacheKey);

    if (cached) {
      console.log(`Returning spend type with ID ${id} from cache`);
      return cached;
    }

    const result = await repo.getSpendType(id).toPromise();
    const data = result.data;
    if (data === null) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function getSpendTypes(page: number, limit: number) {
  try {
    const cacheKey = `${CACHE_PREFIX}-list-${page}-${limit}`;
    const cached = cacheManager.getItem(cacheKey);

    if (cached) {
      return cached;
    }

    const result = await repo.getSpendTypes(page, limit).toPromise();
    const data = result.data;
    if (data.length === 0) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function updateSpendType(id: number, data: Partial<SpendType>) {
  try {
    const result = await repo.updateSpendType(id, data).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function deleteSpendType(id: number) {
  try {
    await repo.deleteSpendType(id).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function matchSpendTypes(items: Array<{ description: string }>) {
  try {
    const result = await repo.matchSpendTypes(items).toPromise();
    if (!result) throw new Error('No response from repository');
    return result.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export {
  createSpendType,
  getSpendType,
  getSpendTypes,
  updateSpendType,
  deleteSpendType,
  matchSpendTypes,
};

